import React from 'react';
import { pickFunction } from 'Helpers/Affordances';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import SelectScenarioButton from './SelectScenarioButton';

const SelectScenarioButtonPicker = () => {
  const { pageContentResource } = usePageContentContext();

  return pickFunction(pageContentResource, {
    [fr.relationships.activationConfirmation.name]: () => {
      return (<SelectScenarioButton />);
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default SelectScenarioButtonPicker;
